import Button from "../../components/ui/Button";
import Modal from "../../components/ui/Modal";
import React, { useState } from "react";
import "./UpdatePriceModel.css";

interface UpdatePriceModalProps {
  item: {
    item: string;
    amount: number;
    currency: string;
  };
  onClose: () => void;
  onSave: (newPrice: number) => void;
  isSubmitting?: boolean;
}

const UpdatePriceModal: React.FC<UpdatePriceModalProps> = ({
  item,
  onClose,
  onSave,
  isSubmitting = false,
}) => {
  const [price, setPrice] = useState(item.amount.toString());

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (isSubmitting) return;
    onSave(Number(price));
  };

  return (
    <Modal title={<>Update Cart Price</>} onClose={onClose} size="medium">
<div className="modal-content legacy-modal-content">

        <form onSubmit={handleSubmit}>
          <div className="price-input-group">
            <label>Item</label>
            <p className="item-name">{item.item}</p>

            <label>Current Price</label>
            <p className="current-price">
              {item.currency === "GBP"
                ? "£"
                : item.currency === "USD"
                  ? "$"
                  : item.currency === "EUR"
                    ? "€"
                    : item.currency === "NGN"
                      ? "₦"
                      : item.currency}
              {item.amount}
            </p>

            <label>New Price</label>
            <input
              type="number"
              value={price}
              onChange={(e) => setPrice(e.target.value)}
              min="0"
              step="0.01"
              required
              className="price-input"
            />
          </div>
          <Button
            type="submit"
            className="update-price-btn"
            disabled={isSubmitting}
          >
            {isSubmitting ? "Updating..." : "Update Price"}
          </Button>
        </form>
      </div>
</Modal>
  );
};

export default UpdatePriceModal;
